import React from 'react'
import ResettableInput from '../../form/input/ResettableInput'
import { t } from '@lingui/macro'
import { useFeatureFlags } from 'front-end/src/app/hooks/useFeatureFlags'
import { useMembersSelectorContext } from '../MembersSelectorContext'
import { IMembersSelectorMembers } from '../MembersSelectors.types'
import { observer } from 'mobx-react-lite'

type InputMemberProps = {
  inputRef?: (input: HTMLInputElement) => void
  addressBook?: IMembersSelectorMembers
}

export const InputMember: React.FC<InputMemberProps> = observer(
  ({ inputRef }) => {
    const { featureFlags } = useFeatureFlags()
    const { query, reset, setShowMembersList, setShowAddressBook, setQuery } =
      useMembersSelectorContext()

    const handleInputFocus = () => {
      setShowMembersList(query.length > 0)
      setShowAddressBook(false)
    }

    return (
      <ResettableInput
        placeholder={
          featureFlags?.account_name_login
            ? t`Enter names, account names, or email addresses`
            : t`Enter names, or email addresses`
        }
        autoComplete="new-password"
        onFocus={handleInputFocus}
        value={query}
        onChange={setQuery}
        title={t`Members selector`}
        showResetButton={!!query}
        onReset={reset}
        inputRef={inputRef}
      />
    )
  }
)
